/* eslint-disable prettier/prettier */
import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

import UsersPage from 'Containers/pages/users';
import { APP_ROUTES } from 'Utils/appShell';
import { AUTH_STATES } from 'Utils/constants';
import { setPostSigninRedirectPath } from 'Actions/authUser';
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core';

const DashboardPage = lazy(() => import('Containers/pages/dashboard'));
const EmployeesPage = lazy(() => import('Containers/pages/employees'));

class PrivateRoute extends React.Component {
  componentDidMount() {
    const {
      userAuthenticated,
      restrictedToRole,
      location,
      setPostSigninRedirectPath,
    } = this.props;
    const currentUserRole = sessionStorage.getItem('userRole');
    if (!userAuthenticated) {
      setPostSigninRedirectPath(location.pathname);
    } else if (restrictedToRole && restrictedToRole !== currentUserRole) {
      // redirect to home page
      console.warn(
        'Access denied for current role, restricted to role: ',
        restrictedToRole
      );
      this.setState({ denyAccess: true });
    }
  }

  state = {
    denyAccess: false,
  };

  render() {
    const {
      component: Component,
      userAuthenticated,
      history,
      ...rest
    } = this.props;
    const { denyAccess } = this.state;
    //const { loaded } = this.state;
    //if (!loaded) return null;
    return (
      <Route
        {...rest}
        render={props => {
          if (!userAuthenticated) {
            return <Redirect to={APP_ROUTES.AUTH_SIGNIN} />;
          }
          if (denyAccess) {
            return (
              <>
                <Dialog
                  open={denyAccess}
                  aria-labelledby="alert-deny-access-title"
                  aria-describedby="alert-deny-access-desc"
                >
                  <DialogTitle id="alert-deny-access-title">
                    <Typography color="error" variant="h5">
                      {'Access Denied'}
                    </Typography>
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-deny-access-desc">
                      <Typography variant="subtitle2" color="textPrimary">
                        You do not have permission to access this page. You will
                        be redirected to the home page.
                      </Typography>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => history.push(APP_ROUTES.ROOT)}
                      variant="outlined"
                      color="primary"
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            );
          }
          return <Component {...props} />;
        }}
      />
    );
  }
}

PrivateRoute.propTypes = {
  component: PropTypes.object.isRequired,
  restrictedToRole: PropTypes.string,
  userAuthenticated: PropTypes.bool.isRequired,
  currentUserRole: PropTypes.string,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  setPostSigninRedirectPath: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  userAuthenticated: state.authUser.userAuthState === AUTH_STATES.SIGNED_IN,
  currentUserRole: state.authUser.userProfile.role,
});

PrivateRoute = compose(
  withRouter,
  connect(
    mapStateToProps,
    { setPostSigninRedirectPath }
  )
)(PrivateRoute);

const Routes = props => (
  <Suspense fallback={<div />}>
    <Switch>
      <Redirect exact path={APP_ROUTES.ROOT} to={APP_ROUTES.DASHBOARD_PAGE} />
      <PrivateRoute
        path={APP_ROUTES.DASHBOARD_PAGE}
        component={DashboardPage}
      />
      <PrivateRoute
        path={APP_ROUTES.EMPLOYEES_PAGE}
        component={EmployeesPage}
      />
      <PrivateRoute
        path={APP_ROUTES.USERS_PAGE}
        component={UsersPage}
        restrictedToRole={process.env.AUTH_ROLE_CORP_HR_ADMIN}
      />
    </Switch>
  </Suspense>
);

export default Routes;
